<template>
    <div v-if="document">
        <h1 class="title title--line"><T :title="document.title">Bent u zeker dat u het document "@title" wil wijzigen?</T></h1>
        <p><T>Let op: de huidige versie van het document wordt gewist.</T></p>
        <div class="d-flex">
            <router-link :to="{ name: 'documents', params: { document: document.slug }}" class="button button--ghost">
                <i class="icon-chevron-left button--icon button__icon--left"></i> <T>Terug</T>
            </router-link>
            <button v-if="document.copyRequired" @click="deleteDocument();" class="button ml-auto">
                <T>Ja, ga verder</T>
            </button>
            <router-link v-else="!document.copyRequired" :to="{ name: 'document-process', params: { document: document.slug }}" class="button ml-auto">
                <T>Ja, ga verder</T>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'DocumentConfirmEdit',
        data: function(){
            return {
                document: null,
                nextRouteName: null,
            };
        },
        computed: mapState(['activeLocale']),
        watch: {
            // when the activeLocale change then try to translate again
            activeLocale() {
                this.getDocument();
            },
        },
        methods: {
            getDocument () {
                let self = this;
                self.$store.commit('setLoading',true);

                // get the current document
                this.$Api.get('document/' + this.$route.params.document, {isConfirm: true})
                        .then(function(response) {
                            self.document = response.data;
                            // create a field for the document to be uploaded
                        })
            },
            deleteDocument() {
                let self = this;
                this.$Api.get('document-delete/' + this.$route.params.document)
                        .then(function (response) {
                            self.nextRouteName = "document-upload";
                            self.redirectToNextRoute();
                        })
            },
            redirectToNextRoute() {
                this.$router.push({name: this.nextRouteName, params:{ document: this.document.slug} });
            },
        },
        created: function() {
            this.getDocument();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/DocumentConfirmEdit.vue